import { Jurisdiction } from '@gig/magic-jurisdictions';
import { USER_JURISDICTION_QUERY } from '@gig/magic-messages';

export function getUserJurisdiction() {
    return window.queryBus.query<Jurisdiction>(USER_JURISDICTION_QUERY);
}
